import EventBus from '@/utils/event-bus'
import userApi from '@/modules/user/api/'
import * as types from './mutation-types'

export const defaultModuleName = 'user'

export default {
  namespaced: true,

  state: {
    current_user: null,
  },

  getters: {
    authUserInfo (state) {
      return state.current_user
    },
  },

  mutations: {
    // !!!
    onLogout(state){
      state.current_user=null;
    },
    [types.UPDATE_AUTH_USER_INFO]: (state, userInfo) => {
      state.current_user = userInfo
    },
  },

  actions: {
    onLogout ({commit}) {
      EventBus.$emit('user:logout')
      console.log()
      commit('onLogout');
    },
    async me ({state, commit, dispatch, getters}, refresh = false) {
      let currentUser = getters.authUserInfo

      if (refresh || !currentUser) {
        currentUser = await dispatch('refreshAuthUser')
      }

      return currentUser
    },

    async refreshAuthUser ({commit}) {
      try {
        const resp = await userApi.getMe()

        commit(types.UPDATE_AUTH_USER_INFO, resp.data)
        EventBus.$emit('user::updated-info')

        return resp.data
      } catch (e) {
        return null
      }
    },
  },
}
